import Swiper, {Autoplay, EffectFade, Navigation, Pagination, Parallax, Thumbs} from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Parallax, EffectFade, Autoplay, Thumbs]);
window.VegasCarousel = {
	init: function ($carousel, nativeOption = {}) {
		if ($carousel) {
			VegasCarousel.carousel($carousel, nativeOption);
		} else {
			let $carousels = $('.swiper');

			if ($carousels.length) {
				$carousels.each(function () {
					VegasCarousel.carousel($(this), {})
				});
			}
		}
	},

	carousel: function ($self, nativeOption) {
		let swiper,
			options,
			isInit = '' + $self.data('init');

		if (isInit !== 'false') {
			if (nativeOption.length) {
				options = nativeOption;
			} else {
				options = $.extend (
					VegasCarousel.setOptions($self),
					VegasCarousel.setNavigation($self),
					VegasCarousel.setPagination($self),
					VegasCarousel.setEffects($self),
					VegasCarousel.setAutoplay($self),
					VegasCarousel.setThumbs($self),
					VegasCarousel.setFirstVideoPlay($self)
				);
			}

			swiper = new Swiper('#' + $self.attr('id'), options);

			// API
			let event = $self.data('event') || 'none';
			VegasCarousel.events(swiper, event);
		}

		return swiper;
	},

	events: function (self, event) {
		let $container = $(self.$el);

		// Смена слайдов при наведении на пагинацию
		if (event === 'dots-hover') {
			let $bullets = $container.find('.swiper-pagination-bullet'),
				$link = $container.closest('.vg-shop-prd').find('.prd-link');

			$bullets.hover(function () {
				self.slideTo($(this).index());
			});

			$bullets.click(function () {
				location.href = $link.attr('href');
			})
		}
	},

	setOptions: function ($self) {
		return {
			breakpoints:  $.extend(VegasCarousel.setBreakpoints($self), VegasCarousel.setResponsive($self)),
			slidesPerGroup: $self.data('per-group') || 1,
			height: $self.data('height') || 'auto',
			loop: !!$self.data('loop') || false,
			mousewheel: !!$self.data('mousewheel') || false,
			simulateTouch: $self.data('touch-mouse') !== 'false',
			centeredSlides: !!$self.data('centered') || false,
			freeMode: !!$self.data('free-mode') || false,
			parallax: !!$self.data('parallax') || false,
			speed: $self.data('speed') || 1000,
		}
	},

	setThumbs: function ($self) {
		let Thumbs = !!$self.data('thumbs') || false,
			$thumbs = $('#' + $self.data('thumbs')),
			thumbs = {};

		if (Thumbs && $thumbs.length) {
			let swiper = new Swiper('#' + $self.data('thumbs'), VegasCarousel.setOptions($thumbs));

			thumbs = {
				thumbs: {
					swiper: swiper
				}
			}
		}

		return thumbs;
	},

	setAutoplay: function ($self) {
		let autoPlay = !!$self.data('autoplay') || false,
			autoPlayDelay = $self.data('autoplay-delay') || 5000,
			autoplay = {};

		if (autoPlay) {
			autoplay = {
				autoplay: {
					delay: autoPlayDelay,
					disableOnInteraction: false,
				}
			}
		}

		return autoplay;
	},

	setEffects: function ($self) {
		let effect = !!$self.data('effect') || false,
			effects = {};

		if (effect) {
			effects = {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
			}
		}

		return effects;
	},

	setNavigation: function ($self) {
		let nav = !!$self.data('nav') || false,
			navigation = {};

		if (nav && VegasCarousel.checkNavigable($self)) {
			navigation = {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}
			}
		}

		return navigation;
	},

	setPagination: function ($self) {
		let dots = !!$self.data('dots') || false,
			progressbarOpposite = !!$self.data('dots-progress') || false,
			pagination = {};

		if (dots && VegasCarousel.checkNavigable($self)) {
			pagination = {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
					progressbarOpposite: progressbarOpposite,
				},
			}
		}

		return pagination;
	},

	setBreakpoints: function ($self) {
		let items = $self.data('items') || false,
			spaceBetween = $self.data('margin') || 0;

		return {
			0: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 24
			},
			640: {
				slidesPerView: items || 2,
				spaceBetween: spaceBetween
			},
			767: {
				slidesPerView: items || 2,
				spaceBetween: spaceBetween
			},
			991: {
				slidesPerView: items || 2,
				spaceBetween: spaceBetween
			},
			1199: {
				slidesPerView: items,
				spaceBetween: spaceBetween
			}
		};
	},

	setResponsive: function ($self) {
		let params = {};

		let xs = $self.data('xs') || false; // 0px
		if (xs) {
			params['0'] = xs;
		}

		let sm = $self.data('sm') || false; // 670
		if (sm) {
			params['640'] = sm;
		}

		let md = $self.data('md') || false; // 767px
		if (md) {
			params['767'] = md;
		}

		let lg = $self.data('lg') || false; // 991px
		if (lg) {
			params['991'] = lg;
		}

		return params;
	},

	checkNavigable: function ($self) {
		// Узнаем нужна ли на пагинация и навигация
		let $container = $('#' + $self.attr('id')),
			count_slides = $container.children('.swiper-wrapper').children('.swiper-slide').length,
			items = VegasCarousel.setOptions($container).breakpoints;

		if (window.innerWidth < 640 && count_slides <= items[0].slidesPerView ) {
			$container.find('.swiper-pagination').hide();
			$container.find('.swiper-button-next').hide();
			$container.find('.swiper-button-prev').hide();

			return false;
		} else if ((window.innerWidth >= 640 && window.innerWidth < 767) && (count_slides <= items['640'].slidesPerView)) {
			$container.find('.swiper-pagination').hide();
			$container.find('.swiper-button-next').hide();
			$container.find('.swiper-button-prev').hide();

			return false;
		} else if ((window.innerWidth >= 767 && window.innerWidth < 991) && (count_slides <= items['991'].slidesPerView)) {
			$container.find('.swiper-pagination').hide();
			$container.find('.swiper-button-next').hide();
			$container.find('.swiper-button-prev').hide();

			return false;
		} else if (window.innerWidth > 1200 && (count_slides <= $self.data('items'))) {
			$container.find('.swiper-pagination').hide();
			$container.find('.swiper-button-next').hide();
			$container.find('.swiper-button-prev').hide();

			return false;
		}

		return true;
	},

	setFirstVideoPlay: function ($self) {
		if ($self.is(':nth-child(3)')) {
			$self.find('video').each(function () {
				$(this).trigger('play');
			});
		}
	}
};
